import React, { useState, useEffect } from 'react';
import './ChatBox.css'; // Make sure to create this CSS file

function ChatGRD() {
    const [question, setQuestion] = useState('');
    const [answer, setAnswer] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const handleQuestionChange = (event) => {
        setQuestion(event.target.value);
    };
    const [token, setToken] = useState('y4334789308ejksdjljw9832a121wq55re');

    useEffect(() => {
        const obtenerUbicacion = async () => {
          const ubicacion = await obtenerUbicacionPorIP();
          console.log('Después de obtenerUbicacionPorIP:', ubicacion.longitude, ubicacion.latitude);
        };
        //obtenerUbicacion();
        const unicacion = {
            longitude: 10,
            latitude: 10
        }
    }, []);

    const obtenerUbicacionPorIP = async () => {
        try {
          const response = await fetch('https://ipapi.co/json/', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            },
          });
          const responseJson = await response.json();
          setLatitude(responseJson.latitude);
          setLongitude(responseJson.longitude);
          console.log('Dentro de obtenerUbicacionPorIP:', responseJson.longitude, responseJson.latitude);
          return responseJson;
        } catch (error) {
          setLongitude(0.0);
          setLatitude(0.0);
          console.error('Error al obtener la ubicación por IP:', error);
          throw error;
        }
    };

    const handleSubmit = async () => {
        if (!question) return;
        setIsLoading(true);
        try {
            console.log(latitude);
            console.log(longitude);
            const requestBody = {
                latitude: latitude,
                longitude: longitude,
                modelo: 'text-embedding-3-small',
                pregunta: question,
            };
            const response = await fetch('https://insurtechsoft.com:8097/openai/askgpt/BUSCAPRODUCTOMILVUS/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Credentials': 'true',
                    'TOKEN': token
                },
                body: JSON.stringify(requestBody),
            });
            if (!response.ok) {
                console.log("Error al consumir ewl servicio");
                console.log(response);
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            setAnswer(data);
        } catch (error) {
            console.error("There was an error!", error);
        }
        //setQuestion(''); // Clear the question field
        setIsLoading(false);
    };
    const limpiarCampos = () => {
        setQuestion(''); 
        setAnswer('');  
    }

    return (
        <div className="chatbox-container">
            <input
                className="chatbox-input"
                type="text"
                value={question}
                onChange={handleQuestionChange}
                placeholder="Escribe las características del seguro que quieres contratar"
            />
            <div className="contenedorBoton" style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <button
                  className={`chatbox-button ${isLoading ? "loading" : ""}`}
                  onClick={handleSubmit}
                  disabled={isLoading}
              >
                {isLoading ? "Enviando..." : "Enviar"}
              </button>
            </div>
            <div className="chatbox-answer">
                {answer && answer.split('\n').map((line, index) => (
                    <React.Fragment key={index}>
                        {line}
                        <br />
                    </React.Fragment>
                ))}
            </div>
            <div className="contenedorBoton" style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <button
                  style={{
                    backgroundColor: '#DFDFDF',
                    border: 'none',
                    color: 'blue',
                    padding: '10px 22px',
                    textAlign: 'center',
                    textDecoration: 'none',
                    display: 'inline-block',
                    fontSize: '12px',
                    margin: '4px 2px',
                    cursor: 'pointer',
                    borderRadius: '8px',
                    width: '95px'
                  }}
                    onClick={limpiarCampos}
                >
                Limpiar
                </button>
            </div>



        </div>
    );
}

export default ChatGRD;
